import React from "react";
import LandingPageLayout from "@/components/LandingPageLayout";

export default function AlexandriaTransfer() {
  return (
    <LandingPageLayout translationKey="alexTransfer" />
  );
}
